import Card from '..';
import { Course, Enum_Bookmark_Category, Enum_Course_Type } from '@edwin-group/cj-graphql';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import Button from '@/components/Button';
import { useNavigate } from 'react-router-dom';
import BookmarkButton from '@/components/Bookmark/BookmarkButton';
import { getAuthors } from '@/utils/learn';
const arrowCourseImg = '/card/arrow-course.png';
const playIcon = '/card/play-icon.png';

const CourseCard = ({
  course,
  showBookmarkIcon,
  onRemoveFromBookmark,
}: {
  course: Course;
  showBookmarkIcon?: boolean;
  onRemoveFromBookmark?: () => void;
}) => {
  const navigate = useNavigate();

  const CardButton = () => {
    const link = `/learn/course/${course.attributes?.slug}`; // TODO

    return (
      <div className="rows-span-1 flex flex-col items-start gap-1">
        <Button
          theme="solid-primary-600"
          onClick={() => {
            if (link) {
              navigate(link);
            }
          }}>
          <img src={playIcon} className="h-auto w-[12px]" alt="play icon" />
          Start
        </Button>
      </div>
    );
  };

  return (
    <Card
      key={course?.attributes?.slug}
      title={course.attributes?.title || ''}
      description={course.attributes?.description || ''}
      author={
        getAuthors(course as Course)
          ?.map((author) => author?.name || author?.attributes?.name)
          .join(', ') || ''
      }
      arrowImg={arrowCourseImg}
      tags={
        <DefaultContentTemplateTags
          tags={[course?.attributes?.type || '']}
          className="!mb-2 !mt-0"
          duration={course?.attributes?.duration || undefined}
        />
      }
      image={{
        url: course.attributes?.thumbnail.data?.attributes?.url || '',
        alternativeText: course.attributes?.thumbnail.data?.attributes?.alternativeText || '',
      }}
      button={<CardButton />}
      bookmarkButton={
        showBookmarkIcon ? (
          <BookmarkButton
            relationId={course?.documentId || ''}
            metadata={course}
            category={
              course?.attributes?.type === Enum_Course_Type.Training
                ? Enum_Bookmark_Category.Training
                : Enum_Bookmark_Category.Cpd
            }
            onRemoveFromBookmark={onRemoveFromBookmark}
          />
        ) : null
      }
    />
  );
};

export default CourseCard;
